import React from 'react';
import { useSelector } from 'react-redux';
import { selectedClientSelector } from '../../store/slices/selectedClient';
import { authSelector } from '../../store/slices/auth';
import Links from './LinksV2';

/**
 * Platform Profile tab — renders only the platform cards (Links component)
 * using the selected client data from Redux.
 */
const PlatformProfile = () => {
  const { selectedClient } = useSelector(selectedClientSelector);
  const { userInfo } = useSelector(authSelector);

  if (!selectedClient?.id) {
    return (
      <div className="text-center py-10">
        <p className="text-muted-foreground">
          Please select a client to view platform profiles.
        </p>
      </div>
    );
  }

  return <Links selectedClient={selectedClient} userInfo={userInfo} />;
};

export default PlatformProfile;
